import React, { useContext, useEffect, useState } from 'react';
import { Card, Dropdown, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useGetDta } from '../../../hooks/useGetDta';
import { useParams } from 'react-router-dom';
import LoadinSpin from '../../ui/LoadinSpin';
import ModNotas from './ModNotas';
import moment from 'moment';
import classNames from 'classnames';
import Confirmation from '../../ui/Confirmation';

const NotasUs = ({ activeTab }) => {
    const { id } = useParams();
    const [show, setShow] = useState(false);

    let idR = atob(id);
    const { loading, data, getInfo } = useGetDta(`usertools/notas/${idR}`);
    const [nota, setNota] = useState({});
    const [showd, setShowd] = useState(false);
    const [info, setInfo] = useState({});
    useEffect(() => {
        getInfo(`usertools/notas/${idR}`);
    }, [activeTab, idR]);
    const showMod = (it) => {
        setNota(it);
        setShow(true);
    };
    const dele = (id) => {
        setInfo({ id, type: 'NOTA' });
        setShowd(true);
    };
    if (loading) return <LoadinSpin />;
    return (
        <div className="tasks">
            <OverlayTrigger key="bottom" placement="bottom" overlay={<Tooltip>Añadir nota</Tooltip>}>
                <button
                    className="btn btn-link p-0 text-secondary float-end shadow-none px-0 py-2"
                    id="addNewTodo"
                    onClick={() => showMod({})}>
                    <i className="mdi mdi-plus"></i>
                </button>
            </OverlayTrigger>

            <h5 className="mt-0 task-header">NOTAS</h5>

            {data.length == 0 && <p className="text-center text-muted pt-2 mb-0">Sin notas</p>}

            {data.map((item, index) => (
                <Card index={'nota' + index}>
                    <Card.Body>
                        <small className="float-end" style={{ whiteSpace: 'break-spaces' }}>
                            {moment(item.createdAt).format('YYYY-MM-DD HH:mm:ss')}
                        </small>
                        <span
                            className={classNames('badge', {
                                'bg-danger': item.tipo === 2,
                                'bg-success': item.tipo === 1,
                            })}>
                            {item.tipo === 1 ? 'Normal' : 'Importante'}
                        </span>

                        <h5 className="mt-2 mb-2">{item.asunto}</h5>

                        <p className="mb-0 m-2">
                            <span className="t mb-2 d-inline-block " style={{ whiteSpace: 'break-spaces' }}>
                                <i className="mdi mdi-comment-multiple-outline text-muted"></i>
                                {item.mensaje}
                            </span>
                        </p>

                        <Dropdown className="float-end" align="end">
                            <Dropdown.Toggle
                                variant="link"
                                className="text-muted card-drop arrow-none cursor-pointer p-0 shadow-none">
                                <i className="mdi mdi-dots-vertical font-18"></i>
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                <Dropdown.Item onClick={() => showMod(item)}>
                                    <i className="mdi mdi-pencil me-1"></i>Editar
                                </Dropdown.Item>
                                <Dropdown.Item onClick={() => dele(item.id)}>
                                    <i className="mdi mdi-delete me-1"></i>Eliminar
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>

                        <p className="mb-0">
                            <span className="align-middle">{item.agente}</span>
                        </p>
                    </Card.Body>
                </Card>
            ))}
            <ModNotas show={show} callBk={getInfo} onClose={() => setShow(false)} data={nota} />
            <Confirmation show={showd} toggle={() => setShowd(false)} info={info} callBk={getInfo} />
        </div>
    );
};

export default NotasUs;
